import { FlowTemplate } from '@keyvue/one-api-client';

const maatwerkTemplate = FlowTemplate.fromObject({
    id: 'maatwerk',
    name: 'Maatwerk (naar jouw wens)',
    templateInfo: {
        icon: 'winck',
        price: '€250-€750',
        shortDescription: 'Creëer een unieke klantreis met onze "Maatwerk Flow". Deze flow stelt u in staat om een klantreis te ontwerpen die perfect aansluit bij uw unieke merk en de specifieke wensen van uw klanten.',
        longDescription: '<strong>We begrijpen dat elke onderneming uniek is en streven ernaar om jouw specifieke behoeften te ondersteunen, zonder onnodige complicaties of gedoe.</strong>'
            + '<br/>'
            + '<br/>'
            + 'Onze maatwerkoplossing omvat persoonlijke service: jij deelt jouw doelstellingen en wat je wilt bereiken, aangezien niemand jouw klanten beter kent dan jij. Vervolgens gaan onze specialisten aan de slag om een op maat gemaakte flow te ontwerpen, specifiek afgestemd op jouw organisatie. Zo zorgen we ervoor dat de marketing automation naadloos aansluit bij jouw behoeften en doelstellingen.',
        usps: [
            'Je ontvangt eerst een offerte zodat je helder hebt wat we doen',
            'Volledig gepersonaliseerde service',
            'Op maat gemaakt',
        ],
    },
}) as FlowTemplate;

export default maatwerkTemplate;
